export const editorAvailableColors = [
    '#000000', '#333333', '#959DAC', '#B7C1D5', '#FFFFFF', '#1054B8', '#6BAAFF', '#ED1C24', '#43A047', '#FAA03F',
];
